import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=df40fda6&scoped=true&"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js&"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsSection.vue?vue&type=style&index=0&id=df40fda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df40fda6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
